export const USERS = [
  {
    id: 1,
    name: "Mark",
    project_id: 3,
    department: "Medicine",
    role: "PI"
  },
  {
    id: 2,
    name: "Ann",
    project_id: 2,
    department: "Neuroscience",
    role: "PI"
  },
  {
    id: 3,
    name: "Mary",
    project_id: 1,
    department: "Nursing",
    role: "PI"
  },
  {
    id: 4,
    name: "John",
    project_id: 3,
    department: "Medicine",
    role: "Key Personnel"
  },
  {
    id: 5,
    name: "Geri",
    project_id: 2,
    department: "Neuroscience",
    role: "Key Personnel"
  },
  {
    id: 6,
    name: "Sam",
    project_id: 2,
    department: "Neuroscience",
    role: "Grant Administrator"
  },
  {
    id: 7,
    name: "Jordan",
    project_id: 1,
    department: "Nursing",
    role: "Key Personnel"
  },
  {
    id: 8,
    name: "Pat",
    project_id: 3,
    department: "Medicine",
    role: "Grant Administrator"
  },
  {
    id: 9,
    name: "Mark",
    project_id: 2,
    department: "Neuroscience",
    role: "Key Personnel"
  },
  {
    id: 10,
    name: "Cameron",
    project_id: 3,
    department: "Medicine",
    role: "Key Personnel"
  }
];